import { render, staticRenderFns } from "./newFooter.vue?vue&type=template&id=3c83eca5&scoped=true&"
import script from "./newFooter.vue?vue&type=script&lang=js&"
export * from "./newFooter.vue?vue&type=script&lang=js&"
import style0 from "./newFooter.vue?vue&type=style&index=0&id=3c83eca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83eca5",
  null
  
)

export default component.exports